export default __webpack_public_path__ + "static/media/TopBanner.0e89f841.png";